import * as queryStringHelpers from "../../lib/queryStringHelpers";
import * as routes from "../../constants/routes";
import ActionButton, {ActionButtonStyle} from "../ActionButton";
import BoxInput from "../BoxInput";
import cardsImageDesktop from "../../images/stacked-cards.png";
import cardsImageDesktop2 from "../../images/stacked-cards@2x.png";
import cardsImageDesktop3 from "../../images/stacked-cards@3x.png";
import cardsImageMobile from "../../images/cards-organic.png";
import cardsImageMobile2 from "../../images/cards-organic@2x.png";
import cardsImageMobile3 from "../../images/cards-organic@3x.png";
import ErrorBoundary from "../ErrorBoundary";
import LandingPageWrapper from "../LandingPageWrapper";
import React, {useEffect, useRef, useState} from "react";
import styles from "./OrganicLandingPage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";
import {RouteComponentProps} from "react-router-dom";

const strings = {
    card: "Credit card",
    email: "Email Address",
    emailToggleText:
        "We may use your email address to send you important information about your application and account(s), as well as other useful products and services.",
    title: "Helping students build credit for over 30 years",
    next: "Next",
    description:
        "This card is offered to students planning to attend or already enrolled in a 2-year or 4-year college.",
};

export default function OrganicLandingPage(props: RouteComponentProps) {
    usePageView(document.title);
    const [emailAddress, setEmailAddress] = useState("");

    const isMountedRef = useRef<boolean>(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        const qs = queryStringHelpers.objectify(window.location.search);
        const queryString = queryStringHelpers.stringify(qs);
        props.history.push(`${routes.ORGANIC_APP}${queryString}`, {
            email: emailAddress,
        });
    }

    return (
        <ErrorBoundary>
            <LandingPageWrapper>
                <Container>
                    <Row className={styles.row}>
                        <Column large={8} className={styles.cardsImageColumn}>
                            <img
                                className={styles.cardsImageMobile}
                                src={cardsImageMobile}
                                srcSet={`${cardsImageMobile} 1x, ${cardsImageMobile2} 2x, ${cardsImageMobile3} 3x`}
                                alt={strings.card}
                            />
                            <img
                                className={styles.cardsImageDesktop}
                                src={cardsImageDesktop}
                                srcSet={`${cardsImageDesktop} 1x, ${cardsImageDesktop2} 2x, ${cardsImageDesktop3} 3x`}
                                alt={strings.card}
                            />
                        </Column>
                        <Column large={4} className={styles.infoColumn}>
                            <form onSubmit={onSubmit}>
                                <div className={styles.title}>{strings.title}</div>
                                <BoxInput
                                    className={styles.emailAddress}
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                    label={strings.email}
                                    placeholder={strings.email}
                                    maxLength={40}
                                    toggleText={strings.emailToggleText}
                                    required={true}
                                    type="email"
                                />
                                <ActionButton
                                    style={ActionButtonStyle.secondary}
                                    label={strings.next}
                                    fullWidth={true}
                                    type="submit"
                                />
                                <div className={styles.description}>{strings.description}</div>
                            </form>
                        </Column>
                    </Row>
                </Container>
            </LandingPageWrapper>
        </ErrorBoundary>
    );
}
